































































import { Component, Vue } from "vue-property-decorator";

import { mapGetters } from "vuex";

@Component({
  data() {
    return {
      form: {},
      rules: {
        cod: [
          {
            required: true,
            message: "Campo obbligatorio",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Campo obbligatorio",
            trigger: "blur",
          },
        ],
        regional_description: [
          {
            required: true,
            message: "Campo obbligatorio",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("rates", ["ratesList"]),
    ...mapGetters(["inLoading"]),
  },
  created() {
    this.$store.dispatch("rates/getRates");
  },
  methods: {
    save() {
      (
        this.$refs.form as Vue & {
          validate: (cb: (valid: boolean) => void) => void;
        }
      ).validate((valid: boolean) => {
        if (valid) {
          let action = "rates/createRates";
          if (this.$data.form.id) {
            action = "rates/editRates";
          }
          this.$store
            .dispatch(action, {
              ...this.$data.form,
            })
            .then((response) => {
              if (response == 201 || response == 200) {
                this.$store.dispatch("rates/getRates");
                this.$data.form = {};
              }
            });
        }
      });
    },
    editRates(rates: any) {
      this.$store.dispatch("rates/editRates", {
        ...rates,
      });
      setTimeout(() => {
        this.$store.dispatch("rates/getRates");
      }, 1000);
    },
  },
})
export default class SettingsRates extends Vue { }
